import { render, staticRenderFns } from "./injectIll.vue?vue&type=template&id=524b1619&scoped=true&"
import script from "./injectIll.vue?vue&type=script&lang=js&"
export * from "./injectIll.vue?vue&type=script&lang=js&"
import style0 from "./injectIll.vue?vue&type=style&index=0&id=524b1619&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524b1619",
  null
  
)

export default component.exports